<template>
  <div id="container">
    <div class="location">
      <ul>
        <li class="home">홈</li>
        <li>적하보험</li>
        <li>상품안내</li>
        <li>조건별 담보안내</li>
      </ul>
    </div>

    <div class="pageTit">
      <div class="conWrap">
        <h2>조건별 담보안내</h2>
        <div class="depLink">
          <button type="button" title="메뉴">
            <span>조건별 담보안내</span>
          </button>
          <ul>
            <li>
              <router-link to="/insursumCargoidm"
                ><span>적하보험의 개요</span></router-link
              >
            </li>
            <li>
              <router-link to="/cargotarProdguid"
                ><span>적하보험의 가입대상</span></router-link
              >
            </li>
            <li>
              <router-link to="/condcovProdguid"
                ><span>조건별 담보안내</span></router-link
              >
            </li>
            <li>
              <router-link to="/insurstrtProdguid"
                ><span>보험의 개시와 종료</span></router-link
              >
            </li>
            <li>
              <router-link to="/premcalProdguid"
                ><span>보험료 산출 및 납입</span></router-link
              >
            </li>
            <li>
              <router-link to="/blaninsurProdguid"
                ><span>포괄보험 안내</span></router-link
              >
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="contents">
      <div class="conWrap">
        <div class="conStyle1">
          <h3 class="conTit floating" id="floating1">입력전 알아야 할 사항</h3>
          <p class="tit">
            보통약관 = 본문약관 (SG Policy or MAR Form) + 협회 적하 보험 약관
            (신/구)
          </p>
          <p class="tit">추가약관 및 특별약관</p>

          <h3 class="conTit floating" id="floating2">용어이해</h3>
          <p class="tit">
            해상보험증권 본문약관 (S.G. Policy and MAR Form Policy)
          </p>
          <p class="txt">
            보험증권에 있어서의 담보위험은 본문의 위험약관에 담보위험을 열거하는
            열거책임주의 또는 열거위험주의의 방식을 취하고 있으며, 열거된 위험은
            다음과 같다.
          </p>
          <ul class="line">
            <li>해상고유의 위험(Perils of the Seas)</li>
            <li>
              화재, 외적, 해적, 표도(Rovers), 강도, 투하, 포획 면허장, 보복 포획
              면허장, 습격, 해상에서의 탈취
            </li>
            <li>
              여하한 국적, 상황 또는 성질 여하를 불문하고 모든 국왕.왕후.인민에
              의한 강류, 억지 및 억류, 선장 및 선원의 악행, 기타 일체의 위험(of
              all other perils)
            </li>
          </ul>
          <p class="tit">해상고유의 위험 (Perils of the seas)</p>
          <p class="txt">
            해상고유의 위험이란 "우연한 해상사고 또는 재해만을 말하며 풍파의
            통상적인 작용은 포함하지 않는다." 라고 보험증권 해석규칙 제7조에
            정의되어 있다.<br />
            구체적으로 해상 고유의 위험은 선박의 충돌.좌초.침몰.전복.악천후에
            의한 화물의 손해 및 해수의 침입 등이며, 화재.악천후를 수반하지 않은
            낙뢰.폭발.하역손해 등은 해상고유의 위험이 아니다.
          </p>
          <p class="tit">기타 일체의 위험 (All other perils)</p>
          <p class="txt">
            기타 일체의 위험이란 보험증권에 열거된 위험과 같은 종류의 위험만을
            포함한다.<br />
            따라서 앞에 열거된 위험 이외의 일체의 위험을 의미하는 것이 아니라
            그와 같은 동종의 위험으로 제한한다는 뜻이다. 이를 동종 제한의
            원칙이라 한다.
          </p>
          <p class="tit">적하보험 기본 조건</p>
          <p class="txt">
            적하보험 약관의 기본 조건에는 구약관상 A/R, A/R(Air), W.A, FPA
            조건이 있고 신약관상으로는 ICC(A), ICC(Air), ICC(B), ICC(C) 조건이
            있다. 이외에도 Total Loss(전손 담보) 조건이 있는데, 이것은 부선에
            적재되는 화물이나 선하증권의 발급 없이 운송되는 화물을 인수하는데
            주로 사용되는 조건으로써 협회 적하 약관과 같이 국제적인 약관은
            아니다.
          </p>
          <p class="tit">적하보험 부가 조건</p>
          <p class="txt">
            전 위험 담보 조건 A/R, A/R(Air) 혹은 ICC(A), ICC(Air) 조건으로
            보험조건을 정한 경우에는 일반적으로 부가조건을 첨부할 필요가 없지만,
            제한 조건인 WA나 FPA 혹은 ICC(B)나 ICC(C)를 보험조건으로 정한
            경우에는 특정위험에 대해 부가조건을 선택하여 추가로 부보 할 수 있다.
            한편, 전 위험 담보 조건으로 보험에 가입한 경우라 하더라도 화물의
            특성에 따라 전 위험 담보 조건에서 면제한 특정위험을 담보 받고자 할
            때는 부가조건에 대한 추가보험료를 납입하여야 한다. 예를 들어 고체
            화공품 Drum이나 Can 이외의 용기로 포장하여 운송할 경우는
            부족손(Shortage)과 정밀 기계류, 유리 및 요업제품의
            파손(Breakage)위험에 대한 담보 요율은 A/R, A/R(Air)나 ICC(A),
            ICC(Air) 조건의 요율에 포함되어 있지 않으므로 동 품목에 있어서
            부족손이나 파손을 보상 받기 위해서는 이에 따른 추가보험료가
            납입되어야한다. 이러한, 부가조건의 종류는 아래와 같다.
          </p>
          <ul class="line">
            <li>
              TPND(Theft, Pilferage and Non-Delivery 도난, 발하, 불착손)<br />
              도난을 의미하는 용어로 Theft와 Pilferage를 사용하고 있는데, 특히
              Pilferage는 좀도둑에 의해 포장 내용물의 일부가 없어지는
              발하(拔河)를 뜻한다. Non-Delivery는 포장 단위의 화물이 송두리째
              목적지에 도착하지 않은 경우를 말한다.
            </li>
            <li>
              RFWD(Rain &amp;/or Fresh Water Damage : 우·담수손)<br />
              빗물 또는 담수에 의한 손해를 보상하는 조건으로서, WA조건으로 보험
              가입할 경우라 하더라도 Sea Water Damage는 담보되나 RFWD는 담보되지
              않으므로 화물의 성질에 따라 본 부가위험조건을 첨부할 필요가 있다.
              부선에 있는 동안 비에 의한 손해가 발생할 수 있다.
            </li>
            <li>
              Breakage(파손)<br />
              A/R 혹은 ICC(A) 조건에서는 법정면책위험과 약관에 명시된 면책위험을
              제외한 모든 위험을 보험자가 보상 하도록 포괄책임주의를 택하고
              있으나, 파손은 운송도중 통상적으로 발생할 수 있는 손해(Ordinary
              Loss)일 수도 있고 화물 고유의 하자 또는 성질을 근인으로 일어나는
              필연적인 손해일 수도 있다. 따라서, 유리 및 도자기 제품, 정밀기기
              등 파손되기 쉬운 화물의 경우에는 보험 조건이 A/R 혹은
              ICC(A)조건이라 할지라도 파손(Breakage) 위험을 추가로 보험 가입 한
              후 해당보험료를 납입하여야 협회 적하 약관(ICC)의 위험약관에 열거된
              담보위험 이외의 위험으로 발생한 파손을 보상 받을 수 있다.
            </li>
            <li>
              Leakage/Shortage(누손/부족손)<br />
              Leakage(누손)는 액체 또는 기체화물이 용기에서 유출되어 나가는
              손해를 말하며, Shortage(부족손)는 주로 중량의 감소(Weight
              Shortage) 혹은 수량의 부족(Loss in Quantity)에 따른 손해를 말한다.
            </li>
            <li>
              Sweat &amp; Heating(습기와 열에 의한 손해)<br />
              Sweat Damage는 선창 내 습기의 응축으로 인하여 화물이 입는
              손해이며, Heating Damage는 곡물 등이 내포되고 있는 습기가 통풍
              불량이나 이상온도의 상승에 의하여 자체적으로 발열하여 발생하는
              손해이다. 이러한 두 가지 손해는 서로 연관되어 발생되므로 구별이
              곤란한 때가 많다.
            </li>
            <li>
              JWOB(Jettison &amp; Washing Over Board : 투하 및 갑판유실)<br />
              일반적으로 해상운송화물은 선창에 적재되는 것이 원칙이지만, 원목,
              차량, 생 동물 등은 갑판에 적재되는 경우가 있는데 이와 같이
              갑판상에 적재된 화물이 투하되거나 풍랑으로 유실되었을 때의 손해를
              말한다. 따라서, 원목의 경우 적하 보험에 부보 할 때에는 FPA+JWOB
              조건으로 부보 하는 것이 바람직하다.
            </li>
            <li>
              COOC(Contact with oil and/or Other Cargo : 유류 및 타 화물과의
              접촉손해)<br />
              화물이 유류 및 기타 화물과 접촉하여 오염되었을 때의 손해를 말한다.
            </li>
            <li>
              Hook and Hole(갈쿠리 손해)<br />
              하역 작업 중 갈쿠리를 사용함으로써 발생되는 손해로 직물류 등의
              화물을 적하보험에 가입할 때 첨부 되는 조건이다.
            </li>
            <li>
              Contamination(오손)<br />
              액체 화공품이나 유류 등이 해수 또는 담수에 의해 입는 품질저하의
              손해를 말한다.
            </li>
          </ul>

          <h3 class="conTit floating" id="floating3">
            협회 구 약관의 보상범위
          </h3>
          <div class="tabStyle3">
            <table>
              <caption>
                협회 구 약관이 보상범위
              </caption>
              <colgroup>
                <col width="*" />
                <col width="100" />
                <col width="100" />
                <col width="100" />
              </colgroup>
              <thead>
                <tr>
                  <th scope="col" rowspan="2">담보위험</th>
                  <th scope="col" colspan="3" height="40">보상여부</th>
                </tr>
                <tr>
                  <th scope="col" height="40">A/R</th>
                  <th scope="col">WA</th>
                  <th scope="col">FPA</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="tal" height="52">
                    S.G Form상 열거위험에 근인한 전부 손해
                  </td>
                  <td>O</td>
                  <td>O</td>
                  <td>O</td>
                </tr>
                <tr>
                  <td class="tal" height="52">
                    화물을 적재한 선박 본선이나 부선의 침몰, 좌초, 대화재 발생시
                    인과관계를 불문한 단독 해손
                  </td>
                  <td>O</td>
                  <td>O</td>
                  <td>O</td>
                </tr>
                <tr>
                  <td class="tal" height="52">
                    화재, 폭발, 충돌, 타 물체와의 충돌 또는 접촉에 기인하여
                    발생한 단독 해손
                  </td>
                  <td>O</td>
                  <td>O</td>
                  <td>O</td>
                </tr>
                <tr>
                  <td class="tal" height="52">
                    선적, 환적, 하역작업 중에 발생한 매 포장 단위당 전부 손해
                  </td>
                  <td>O</td>
                  <td>O</td>
                  <td>O</td>
                </tr>
                <tr>
                  <td class="tal" height="52">
                    공동해손, 구조비, 특별비용, 손해방지비용
                  </td>
                  <td>O</td>
                  <td>O</td>
                  <td>O</td>
                </tr>
                <tr>
                  <td class="tal" height="52">
                    악천후(Heavy Weather)로 인한 단독해손 (분손)
                  </td>
                  <td>O</td>
                  <td>O</td>
                  <td>X</td>
                </tr>
                <tr>
                  <td class="tal" height="52">
                    악천후(Heavy Weather)로 인한 전손
                  </td>
                  <td>O</td>
                  <td>O</td>
                  <td>O</td>
                </tr>
                <tr>
                  <td class="tal" height="52">
                    면책 위험을 제외한 모든 외부적 우발적 원인에 의한 손해
                  </td>
                  <td>O</td>
                  <td>X</td>
                  <td>X</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="info">
            <p>약관상 규정된 면책사항</p>
            <ol>
              <li>
                1. 보험계약자 / 피보험자의 고의 또는 불법 행위로 인한 일체의
                손해
              </li>
              <li>2. 보험가입화물의 고유의 결함, 성질에 기인한 손해</li>
              <li>3. 운송지연으로 인한 손해</li>
              <li>4. 전쟁, 동맹파업, 폭동, 핵무기 등에 기인한 손해</li>
              <li>5. 통상의 손해 및 포장 불충분에 기인한 손해</li>
            </ol>
          </div>

          <h3 class="conTit floating" id="floating4">
            협회 신 약관의 보상범위
          </h3>
          <div class="tabStyle3">
            <table>
              <caption>
                협회 신 약관이 보상범위
              </caption>
              <colgroup>
                <col width="400" />
                <col width="*" />
              </colgroup>
              <thead>
                <tr>
                  <th scope="col" height="80">보험조건</th>
                  <th scope="col">담보위험</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td height="52">ICC(C)</td>
                  <td class="tal lh38">
                    - 화재 또는 폭발<br />
                    - 본선 또는 부선의 좌초, 교사, 침몰, 전복<br />
                    - 육상운송용구의 전복, 탈선, 충돌 및 접촉<br />
                    - 피난항에서의 화물의 하역<br />
                    - 공동해손 희생손해, 투하<br />
                    - 공동해손, 구조비
                  </td>
                </tr>
                <tr>
                  <td height="52">ICC(B)</td>
                  <td class="tal lh38">
                    - 운송용구에 바다, 호수, 강물의 직접적인 유입으로 인한
                    손해<br />
                    - 하역작업중 화물의 포장 단위 당 전손<br />
                    - 지진, 화산의 폭발, 낙뢰<br />
                    - 갑판유실
                  </td>
                </tr>
                <tr>
                  <td height="52">ICC(A)</td>
                  <td class="tal">
                    - 약관상 규정된 면책사항을 제외한 위험으로 인하여 발생한
                    손해는 모두 보상
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <h3 class="conTit floating" id="floating5">
            신/구 약관의 보험조건별 담보범위 비교
          </h3>
          <p class="tit">FPA와 ICC(C) 조건</p>
          <p class="txt">
            두 조건의 큰 차이점은 "선적.환적 또는 하역작업 중의 포장 당 전손"이
            FPA조건에서는 담보되나 ICC(C)조건에서는 담보되지 않는 데 있다.
          </p>
          <p class="tit">W.A.IOP와 ICC(B) 조건</p>
          <div class="tabStyle3">
            <table>
              <caption>
                신/구 약관의 보험조건별 담보범위 비교
              </caption>
              <colgroup>
                <col width="50%" />
                <col width="50%" />
              </colgroup>
              <thead>
                <tr>
                  <th scope="col" height="80">W.A.IOP</th>
                  <th scope="col">ICC(B)</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="tal lh38" height="52">
                    - 전손(Total Loss)<br />
                    - 운송용구의 침몰, 좌초, 화재에 의한 단독해손<br />
                    - 운송용구의 충돌(접촉)에 의한 단독해손<br />
                    - 공동해손 손해<br />
                    - 선적, 하역 작업 시 추락에 의한 포장당 전손<br />
                    - 화재, 폭발, 피난항에서의 화물의 하역에 기인된 단독해손<br />
                    - 특별비용, 손해방지 비용<br />
                    - 황천(Heavy Weather)에 의한 단독해손 (예, 해수 손해)
                  </td>
                  <td class="tal lh38">
                    <strong>하기 위험에 합리적으로 기인된 손해</strong><br />
                    - 화재, 폭발 (1.1.1)<br />
                    - 운송용구의 좌초, 교사, 침몰, 전복, 탈선 (1.1.2 &amp; 3)<br />
                    - 운송용구의 충돌 또는 접촉(1.1.4)<br />
                    - 피난항에서의 화물의 하역(1.1.5)<br />
                    - 지진, 화산의 분화, 낙뢰(1.1.6)<br />
                    <strong>하기위험으로 인한 손해</strong><br />
                    - 공동해손 희생(1.2.1)<br />
                    - 투하, 갑판유실(1.2.2)<br />
                    - 운송용구 또는 보관장소에 해수, 호수, 강물의 유입(1.2.3)<br />
                    <strong
                      >선적, 하역 작업 시 추락에 의한 포장당 전손(1.3)<br />
                      담보위험으로 인한 항해 종료 시 계반 비용, 손해방지 비용
                      (16)</strong
                    >
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <p class="tit">
            W.A.IOP 조건과 ICC(B) 조건의 비교 포인트
          </p>
          <p class="txt">
            - Wet Damage의 원인 위험 확장 - "Heavy Weather" 용어 삭제되고 "해수,
            호수, 강물의 유입"이란 구체적 위험의 형태로 규정<br />
            - 지진, 분화, 낙뢰 위험 담보 규정화 (구약관에는 담보 규정 없음)<br />
            - 갑판유실 위험 담보 규정화 (구약관에는 "Heavy Weather"에 의하면
            담보가능)<br />
            - 손해의 형태 ("분손 담보, 단독해손 부담보"와 같이)를 기준한 담보
            방법에서 손해의 발생 원인(위험)을 기준한 담보 방법으로 변경
          </p>
          <p class="tit">A/R 와 ICC(A) 조건</p>
          <p class="txt">
            두 조건의 담보범위는 모든 외부적 우발적인 손해를 보상하는 것으로서
            동일하다. 그러나, ICC(A) 조건은 A/R 조건보다 면책위험을
            보다 구체적으로 명시하고 있는데 이것이 A/R 조건과 다르다. 즉, 구
            약관에서는 면책 규정을 법률과 관습에 위임하고 약관에는 구체적으로
            명시하지 않아 보험자가 면책하는 위험이 무엇인지 분명하지 않았으나,
            신약관에서는 보험자의 면책위험을 구체적으로 명시하여 피보험자가
            이해하기 용이하게 규정하여 분쟁의 소지를 줄이고 있다.
          </p>

          <h3 class="conTit floating" id="floating6">
            보험조건별 담보위험 요약
          </h3>
          <div class="tabStyle3">
            <table>
              <caption>
                보험조건별 담보위험 요약
              </caption>
              <colgroup>
                <col width="*" />
                <col width="100" />
                <col width="100" />
                <col width="100" />
                <col width="100" />
                <col width="100" />
                <col width="100" />
              </colgroup>
              <thead>
                <tr>
                  <th scope="col" rowspan="2">위험의 종류</th>
                  <th scope="col" colspan="3" height="40">구약관</th>
                  <th scope="col" colspan="3" height="40">신약관</th>
                </tr>
                <tr>
                  <th scope="col" height="40">FPA</th>
                  <th scope="col">WA</th>
                  <th scope="col">A/R</th>
                  <th scope="col">ICC(A)</th>
                  <th scope="col">ICC(B)</th>
                  <th scope="col">ICC(C)</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="tal" height="52">화재 폭발</td>
                  <td>O</td>
                  <td>O</td>
                  <td>O</td>
                  <td>O</td>
                  <td>O</td>
                  <td>O</td>
                </tr>
                <tr>
                  <td class="tal" height="52">좌초 교사 침몰 전복</td>
                  <td>O</td>
                  <td>O</td>
                  <td>O</td>
                  <td>O</td>
                  <td>O</td>
                  <td>O</td>
                </tr>
                <tr>
                  <td class="tal" height="52">육상운송용구의 탈선 전복</td>
                  <td>O</td>
                  <td>O</td>
                  <td>O</td>
                  <td>O</td>
                  <td>O</td>
                  <td>O</td>
                </tr>
                <tr>
                  <td class="tal" height="52">
                    충돌 운송용구와 물 이외의 타물과의 접촉
                  </td>
                  <td>O</td>
                  <td>O</td>
                  <td>O</td>
                  <td>O</td>
                  <td>O</td>
                  <td>O</td>
                </tr>
                <tr>
                  <td class="tal" height="52">피난항에서의 화물의 하역</td>
                  <td>O</td>
                  <td>O</td>
                  <td>O</td>
                  <td>O</td>
                  <td>O</td>
                  <td>O</td>
                </tr>
                <tr>
                  <td class="tal" height="52">공동해손 희생손해</td>
                  <td>O</td>
                  <td>O</td>
                  <td>O</td>
                  <td>O</td>
                  <td>O</td>
                  <td>O</td>
                </tr>
                <tr>
                  <td class="tal" height="52">투하</td>
                  <td>O</td>
                  <td>O</td>
                  <td>O</td>
                  <td>O</td>
                  <td>O</td>
                  <td>O</td>
                </tr>
                <tr>
                  <td class="tal" height="52">선적 하역 작업 중 포장당 전손</td>
                  <td>O</td>
                  <td>O</td>
                  <td>O</td>
                  <td>O</td>
                  <td>O</td>
                  <td>X</td>
                </tr>
                <tr>
                  <td class="tal" height="52">
                    해상에서 점유탈위(전쟁위험 제외)
                  </td>
                  <td>O</td>
                  <td>O</td>
                  <td>O</td>
                  <td>O</td>
                  <td>X</td>
                  <td>X</td>
                </tr>
                <tr>
                  <td class="tal" height="52">
                    선박 외부로부터의 해수침손 1) 전손
                  </td>
                  <td>X</td>
                  <td>O</td>
                  <td>O</td>
                  <td>O</td>
                  <td>O</td>
                  <td>X</td>
                </tr>
                <tr>
                  <td class="tal" height="52">
                    선박 외부로부터의 해수침손 2) 분손
                  </td>
                  <td>O</td>
                  <td>O</td>
                  <td>O</td>
                  <td>O</td>
                  <td>O</td>
                  <td>X</td>
                </tr>
                <tr>
                  <td class="tal" height="52">
                    선박 외부로부터의 강, 호수물의 침입 1) 전손
                  </td>
                  <td>X</td>
                  <td>O</td>
                  <td>O</td>
                  <td>O</td>
                  <td>O</td>
                  <td>X</td>
                </tr>
                <tr>
                  <td class="tal" height="52">
                    선박 외부로부터의 강, 호수물의 침입 2) 분손
                  </td>
                  <td>X</td>
                  <td>O</td>
                  <td>O</td>
                  <td>O</td>
                  <td>O</td>
                  <td>X</td>
                </tr>
                <tr>
                  <td class="tal" height="52">갑판유실</td>
                  <td>X</td>
                  <td>O</td>
                  <td>O</td>
                  <td>O</td>
                  <td>O</td>
                  <td>X</td>
                </tr>
                <tr>
                  <td class="tal" height="52">지진 분화 낙뢰</td>
                  <td>X</td>
                  <td>X</td>
                  <td>O</td>
                  <td>O</td>
                  <td>O</td>
                  <td>X</td>
                </tr>
                <tr>
                  <td class="tal" height="52">도난 발하 불착</td>
                  <td>X</td>
                  <td>X</td>
                  <td>O</td>
                  <td>O</td>
                  <td>X</td>
                  <td>X</td>
                </tr>
                <tr>
                  <td class="tal" height="52">선원의 악행</td>
                  <td>X</td>
                  <td>X</td>
                  <td>O</td>
                  <td>O</td>
                  <td>X</td>
                  <td>X</td>
                </tr>
                <tr>
                  <td class="tal" height="52">해적행위</td>
                  <td>X</td>
                  <td>X</td>
                  <td>X</td>
                  <td>O</td>
                  <td>X</td>
                  <td>X</td>
                </tr>
                <tr>
                  <td class="tal" height="52">선주의 파산</td>
                  <td>X</td>
                  <td>X</td>
                  <td>O</td>
                  <td>X</td>
                  <td>X</td>
                  <td>X</td>
                </tr>
                <tr>
                  <td class="tal" height="52">타화물, 기름과의 접촉</td>
                  <td>X</td>
                  <td>X</td>
                  <td>O</td>
                  <td>O</td>
                  <td>X</td>
                  <td>X</td>
                </tr>
                <tr>
                  <td class="tal" height="52">선박 내의 오수와 접촉</td>
                  <td>X</td>
                  <td>X</td>
                  <td>O</td>
                  <td>O</td>
                  <td>X</td>
                  <td>X</td>
                </tr>
                <tr>
                  <td class="tal" height="52">Rough Handling</td>
                  <td>X</td>
                  <td>X</td>
                  <td>O</td>
                  <td>O</td>
                  <td>X</td>
                  <td>X</td>
                </tr>
                <tr>
                  <td class="tal" height="52">빗물접촉</td>
                  <td>X</td>
                  <td>X</td>
                  <td>O</td>
                  <td>O</td>
                  <td>X</td>
                  <td>X</td>
                </tr>
                <tr>
                  <td class="tal" height="52">Sweat</td>
                  <td>X</td>
                  <td>O</td>
                  <td>O</td>
                  <td>O</td>
                  <td>X</td>
                  <td>X</td>
                </tr>
                <tr>
                  <td class="tal" height="52">1) 악천후로 인한 Sweat</td>
                  <td>X</td>
                  <td>X</td>
                  <td>X</td>
                  <td>X</td>
                  <td>X</td>
                  <td>X</td>
                </tr>
                <tr>
                  <td class="tal" height="52">
                    2) 적도 항해에 따른 온도차이로 인한 Sweat
                  </td>
                  <td>X</td>
                  <td>X</td>
                  <td>X</td>
                  <td>X</td>
                  <td>X</td>
                  <td>X</td>
                </tr>
                <tr>
                  <td class="tal" height="52">
                    3) 화물자체의 성질에 기인한 Sweat
                  </td>
                  <td>X</td>
                  <td>X</td>
                  <td>X</td>
                  <td>X</td>
                  <td>X</td>
                  <td>X</td>
                </tr>
                <tr>
                  <td class="tal" height="52">포장 물량의 잠재적 하자</td>
                  <td>X</td>
                  <td>X</td>
                  <td>X</td>
                  <td>X</td>
                  <td>X</td>
                  <td>X</td>
                </tr>
                <tr>
                  <td class="tal" height="52">
                    물건의 고유성질에 의한 손해 통상적인 손실
                  </td>
                  <td>X</td>
                  <td>X</td>
                  <td>X</td>
                  <td>X</td>
                  <td>X</td>
                  <td>X</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="floatingWrap">
          <a @click="scrollMove('floating1')" id="a1" class="active"
            ><span>적하 보험 약관의 구성</span></a
          >
          <a @click="scrollMove('floating2')" id="a2" class=""
            ><span>용어이해</span></a
          >
          <a @click="scrollMove('floating3')" id="a3" class=""
            ><span>협회 구 약관이 보상범위</span></a
          >
          <a @click="scrollMove('floating4')" id="a4" class=""
            ><span>협회 신 약관의 보상범위</span></a
          >
          <a @click="scrollMove('floating5')" id="a5" class=""
            ><span
              >신/구 약관의 보험조건별<br />
              담보범위 비교</span
            ></a
          >
          <a @click="scrollMove('floating6')" id="a6" class=""
            ><span>보험조건별 담보위험 요약</span></a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
// @ is an alias to /src

import { ref, reactive, inject, onMounted, onBeforeUpdate } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import util from "@/common/util";
import { sessionUserInfo, load } from "@/common/sessionFactory";
import Header from "@/components/common/Header.vue";
import Footer from "@/components/common/Footer.vue";
const handlePopupClose = () => {};
const PopChkNeedRef = ref(null);
const openPopup = (name) => {
  if ("PopChkNeed" == name) {
    PopChkNeedRef.value.open();
  }
};

const scrollMove = (o) => {
  $(".floatingWrap a").removeClass();
  $("#a" + o.slice(-1)).addClass("active");

  const element = document.getElementById(o);
  if (element) {
    element.scrollIntoView({ behavior: "smooth", block: "center" });
  }
};
</script>

<style></style>
